import Legend from './legend'

export default Legend
